// extracted by mini-css-extract-plugin
export default {"overlay":"w8nvPKlVViXqbcAr1uaD"};